type GetClientCookieOptions = {
  dontTrimValues?: boolean;
};

export const getClientCookies = ({
  dontTrimValues,
}: GetClientCookieOptions = {}): Record<string, string | undefined> => {
  if (typeof window === 'undefined') {
    return {};
  }

  let pairs = window.document.cookie.split(';');

  return pairs.reduce<Record<string, string>>((store, pair) => {
    const [name, ...rest] = pair.split('=');

    const key = decodeURIComponent(name.trim());

    if (key.length === 0) {
      return store;
    }

    let value = decodeURIComponent(rest.join('='));

    if (dontTrimValues !== true) {
      value = value.trim();
    }

    return {
      ...store,
      [key]: value,
    };
  }, {});
};
